module.exports = __webpack_public_path__ + "static/img/ys-1.079aa70.webp";


//////////////////
// WEBPACK FOOTER
// ./static/images/ys-1.webp
// module id = SHhk
// module chunks = 11